import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";

export const faqListAction = createAsyncThunk(
    'faq/list', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.get('school/faq/list')
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })